let fallbackCounter = 0;

function getCrypto() {
  return typeof window !== "undefined" ? window.crypto : null;
}

function bytesToHex(bytes) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function randomHex(byteLength = 8) {
  const size = Math.max(1, Number(byteLength) || 1);
  const cryptoObj = getCrypto();

  if (cryptoObj?.getRandomValues) {
    const bytes = new Uint8Array(size);
    cryptoObj.getRandomValues(bytes);
    return bytesToHex(bytes);
  }

  fallbackCounter += 1;
  return `${Date.now().toString(16)}${fallbackCounter.toString(16)}`;
}

export function createRandomId(prefix = "id") {
  const safePrefix = String(prefix || "id");
  const cryptoObj = getCrypto();

  if (cryptoObj?.randomUUID) {
    return `${safePrefix}_${cryptoObj.randomUUID()}`;
  }

  return `${safePrefix}_${Date.now().toString(36)}_${randomHex(8)}`;
}

export function randomStringFromAlphabet(length, alphabet) {
  const size = Math.max(0, Number(length) || 0);
  const chars = String(alphabet || "");
  if (!size || !chars) return "";

  const cryptoObj = getCrypto();
  if (!cryptoObj?.getRandomValues) {
    throw new Error("Secure random generator is unavailable");
  }

  const maxValidByte = Math.floor(256 / chars.length) * chars.length - 1;
  const buffer = new Uint8Array(Math.max(16, size * 2));
  let out = "";

  while (out.length < size) {
    cryptoObj.getRandomValues(buffer);
    for (const byte of buffer) {
      if (byte > maxValidByte) continue;
      out += chars[byte % chars.length];
      if (out.length === size) break;
    }
  }

  return out;
}
